import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  className?: string;
  /** Centers the spinner on a full viewport canvas (auth / page boots). */
  fullscreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  text,
  className = '',
  fullscreen = false,
}) => {
  const classes = [
    'loading-spinner-container',
    size,
    fullscreen ? 'loading-spinner-container--fullscreen' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="status" aria-live="polite" aria-busy="true">
      <div className="loading-spinner-mark" aria-hidden="true">
        <span className="loading-spinner-ring" />
      </div>
      {text ? <p className="loading-text">{text}</p> : <span className="sr-only">Loading</span>}
    </div>
  );
};

export default LoadingSpinner;
